export const isEmptyObject = (obj: object | undefined | null) => {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
};
